export default {
  itens(state) {
    return state.itens;
  },
  item(state) {
    return state.item;
  },
  selects(state) {
    return state.selects;
  },
  produtos(state) {
    return state.produtos;
  },
  filtros(state) {
    return state.filtros;
  }
};
